import React, { useEffect, lazy, useCallback } from 'react'
import AuthRoute from './AuthRoute'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
    Route,
    Switch,
    useLocation,
} from 'react-router-dom';
import { checkLogin } from '../features/Auth/_redux/authAction';
const ShowBlog = lazy(() => import('../features/Blog/show'));
const Blog = lazy(() => import('../features/Blog'));
const GetCode = lazy(() => import('../features/Auth/getcode'));
const Login = lazy(() => import('../features/Auth/login'));
const Home = lazy(() => import('../features/Home'));
const Contact = lazy(() => import('../features/Contact'));
const Catalog = lazy(() => import('../features/Catalog'));
const Term = lazy(() => import('../features/Term'));


const AppRoute = () => {
    const { user } = useSelector(({ auth, http }) => ({ ...auth, ...http }), shallowEqual),
        dispatch = useDispatch(),
        location = useLocation(),
        checkLoginCallback = useCallback(() => {
            if (!["/login", "/get-code", "/term"].includes(location.pathname))
                dispatch(checkLogin())
        }, [dispatch, location])
    useEffect(() => {
        checkLoginCallback()
    }, [checkLoginCallback])
    return (
        <Switch>

            <Route exact path='/' component={Home} />
            <Route exact path='/term' component={Term} />
            <Route exact path='/blogs' component={Blog} />
            <Route exact path='/blogs/:id/:title' component={ShowBlog} />
            <Route exact path='/contact' component={Contact} />
            <Route exact path='/catalogs' component={Catalog} />
            <Route exact path="/get-code" component={GetCode} />
            <Route exact path="/login" component={Login} />
            <AuthRoute isLogin={user?.access_token !== null} from={location.pathname} />
        </Switch>
    )
}

export default AppRoute